/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_page = /** @type {(inputs: {}) => string} */ () => {
	return `Página`
};

const en_accounts_page = /** @type {(inputs: {}) => string} */ () => {
	return `Page`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_page = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_page(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_page", locale)
	if (locale === "es") return es_accounts_page(inputs)
	return en_accounts_page(inputs)
};
export { accounts_page as "accounts.page" }